import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../../../axiosInstance";
import { API_URL } from "../../../../config";
import { IoAddCircle } from "react-icons/io5";

function EmpEmailTemplatePage() {
    const navigate = useNavigate();
    const [templates, setTemplates] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchEmailTemplates();
    }, []);

    useEffect(() => {
        let dataTable = null;
        if (!loading && templates.length > 0) {
            const $ = window.$;
            // Destroy existing DataTable if it exists
            if ($.fn.DataTable.isDataTable('#email_templates_table')) {
                $('#email_templates_table').DataTable().destroy();
            }

            // Initialize new DataTable
            dataTable = $('#email_templates_table').DataTable({
                responsive: true,
                searching: true,
                ordering: true,
                paging: true,
                pageLength: 10,
                destroy: true,
                autoWidth: false,
                dom: 'Bfrtip',
                language: {
                    search: "Search:",
                    searchPlaceholder: "Search templates...",
                    emptyTable: "No email templates available",
                    zeroRecords: "No matching templates found"
                },
                columnDefs: [
                    { orderable: false, targets: [2, 5] }, // Disable sorting for body and actions columns
                    { searchable: true, targets: [0, 1, 3, 4] }, // Enable searching for title, subject, status, and language
                    { 
                        targets: 2,
                        render: function(data, type, row) {
                            if (type === 'display') {
                                return data?.length > 100 ? data.substr(0, 97) + '...' : data;
                            }
                            return data;
                        }
                    }
                ],
                order: [[0, 'asc']], // Sort by Title by default
                drawCallback: function() {
                    // Reinitialize tooltips after table draw
                    $('[data-bs-toggle="tooltip"]').tooltip();
                }
            });
        }

        // Cleanup function
        return () => {
            if (dataTable) {
                dataTable.destroy();
            }
        };
    }, [loading, templates]);

    const fetchEmailTemplates = async () => {
        try {
            const response = await axiosInstance.get(`${API_URL}/admin/get-all-emailTemplate`);
            if (response.data.status === 200) {
                setTemplates(response.data.data || []);
            }
        } catch (error) {
            console.error("Failed to fetch email templates", error);
        } finally {
            setLoading(false);
        }
    };

    const handleEdit = async (id) => {
        try {
            const response = await axiosInstance.get(`${API_URL}/admin/get-emailTemplate/${id}`);
            if (response.data.status === 200) {
                navigate("/employer/emails-edit", {
                    state: { template: response.data.data }
                });
            } else {
                alert("Failed to fetch template details.");
            }
        } catch (error) {
            console.error("Error fetching email template detail", error);
            alert("Something went wrong!");
        }
    };

    const handleAdd = () => {
        navigate("/employer/emails-add");
    };

    return (
        <>
            <div className="wt-admin-right-page-header clearfix">
                <h2>Email Templates</h2>
                <div className="breadcrumbs">
                    <a href="#">Home</a> <a href="#">Dashboard</a> <span>Emails</span>
                </div>
            </div>

            <div className="panel panel-default site-bg-white m-t30">
                <div className="panel-heading wt-panel-heading p-a20 d-flex justify-content-between align-items-center">
                    <h4 className="panel-tittle m-a0">
                        <i className="fa fa-suitcase" /> Email Templates
                    </h4>
                    <button onClick={handleAdd} className="site-button m-r5">
                        {/* <IoAddCircle style={{ color: 'white', marginRight: '5px' }} />  */}
                        Add Email
                    </button>
                </div>

                <div className="panel-body wt-panel-body">
                    <div className="p-a20 table-responsive">
                        <table id="email_templates_table" className="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Title</th>
                                    <th>Subject</th>
                                    <th>Body</th>
                                    <th>Status</th>
                                    <th>Language</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {!loading && templates.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.title || 'N/A'}</td>
                                        <td>{item.subject || 'N/A'}</td>
                                        <td>{item.body || 'N/A'}</td>
                                        <td>
                                            <span className={`badge ${item.status === "active" ? "bg-success" : "bg-danger"}`}>
                                                {item.status || 'N/A'}
                                            </span>
                                        </td>
                                        <td>{item.lang?.toUpperCase() || 'N/A'}</td>
                                        <td>
                                            <div className="twm-table-controls">
                                                <ul className="twm-DT-controls-icon list-unstyled">
                                                    <li>
                                                        <button 
                                                            title="Edit" 
                                                            data-bs-toggle="tooltip" 
                                                            data-bs-placement="top"
                                                            onClick={() => handleEdit(item.id)}
                                                            className="btn btn-sm btn-light"
                                                        >
                                                            <span className="far fa-edit" />
                                                        </button>
                                                    </li>
                                                </ul>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th>Title</th>
                                    <th>Subject</th>
                                    <th>Body</th>
                                    <th>Status</th>
                                    <th>Language</th>
                                    <th>Actions</th>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </>
    );
}

export default EmpEmailTemplatePage;
